import axios from 'axios';

class CountriesService {
	countriesAPI = '/api/api/countries?onlySupported=true';
	supportedCountriesAPI = '/api/api/countries/regions';

	async fetchAllCountriesCommonNames(): Promise<string[]> {
		const response = await axios.get(this.countriesAPI);
		const countries = response.data;
		const commonNames: string[] = countries.map((country: any) => country.nicename);
		const sortedCommonNames = commonNames.sort((a: string, b: string) => a.localeCompare(b));
		return sortedCommonNames;
	}

	async fetchSupportedCountriesCommonNames(): Promise<string[]> {
		const response = await axios.get(this.supportedCountriesAPI);
		const countries = response.data;
		return countries.map((country: any) => country.nicename);
	}
}

export const countriesService = new CountriesService();
